// removed by extract-text-webpack-plugin
module.exports = {"events":"events","events__item":"events__item","events__item-wrap":"events__item-wrap","img":"img","descr":"descr","descr__title":"descr__title","events-detail":"events-detail","events-detail__link-back":"events-detail__link-back","events-detail__title":"events-detail__title","title":"title","events-detail__subtitle":"events-detail__subtitle","events-detail__date":"events-detail__date","events-detail__img":"events-detail__img","events-detail__img-descr":"events-detail__img-descr"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_events.scss
// module id = 269
// module chunks = 0